import { Routes } from '@angular/router';
import { AboutComponent } from 'app/features/about/about.component';
import { AnalyzeComponent } from 'app/features/analyze/analyze.component';
import { ExportComponent } from 'app/features/export/export.component';
import { FlightsCalendarComponent } from 'app/features/flights/flights-calendar/flights-calendar.component';
import { FlightsComponent } from 'app/features/flights/flights.component';
import { PreferencesComponent } from 'app/features/preferences/preferences.component';
import { SearchComponent } from 'app/features/search/search-form/search.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { FlightDetailComponent } from 'app/features/flights/flight-detail/flight-detail.component';
import { SequenceDetailComponent } from 'app/features/flights/sequence-detail/sequence-detail.component';
import { BarChartComponent } from 'app/features/analyze/chart/bar-chart/bar-chart.component';
import { SearchResultComponent } from 'app/features/search/search-result/search-result.component';
import { PieChartComponent } from 'app/features/analyze/chart/pie-chart/pie-chart.component';
import { ComboChartComponent } from 'app/features/analyze/chart/combo-chart/combo-chart.component';
import { FlightListComponent } from 'app/features/flights/flight-list/flight-list.component';
import { VersionComponent } from 'app/features/about/children/version/version.component';
import { FeedbackComponent } from 'app/features/about/children/feedback/feedback.component';
import { isAuthenticated } from '@shared/guards/auth.guard';
import { RedirectComponent } from '@shared/components/redirect/redirect.component';
import { FaqComponent } from 'app/features/about/children/faq/faq.component';
import { AdminComponent } from 'app/features/admin/admin.component';
import { PieChartVariantComponent } from 'app/features/analyze/chart/pie-chart/aircraft-variant/pie-chart-variant.component';
import { CacheViewerComponent } from 'app/features/admin/cache-viewer/cache-viewer.component';
import { DisclaimerComponent } from 'app/features/about/children/disclaimer/disclaimer.component';

export const ROUTES: Routes = [
   
    { path: '', redirectTo: 'flights', pathMatch: 'full' },
    { 
        path: 'flights', 
        component: FlightsComponent,
        children: [
            { path: 'flight-table', component: FlightListComponent },
            { path: 'flight-calendar', component: FlightsCalendarComponent },
            { path: '', redirectTo: 'flight-table', pathMatch: 'full' },
        ],
        canActivate: [isAuthenticated]
    },
    { path: 'flight-detail', component: FlightDetailComponent },
    { path: 'sequence-detail', component: SequenceDetailComponent },
    { path: 'analyze', component: AnalyzeComponent, canActivate: [isAuthenticated] },
    { path: 'analyze/bar-chart', component: BarChartComponent },
    { path: 'analyze/pie-chart', component: PieChartComponent },
    { path: 'analyze/pie-chart/variants/:index', component: PieChartVariantComponent },   
    { path: 'analyze/line-chart', component: ComboChartComponent },
    { path: 'search', component: SearchComponent, canActivate: [isAuthenticated] },
    { path: 'search/result', component: SearchResultComponent},
    { path: 'export', component: ExportComponent, canActivate: [isAuthenticated] },
    { path: 'preferences', component: PreferencesComponent, canActivate: [isAuthenticated] },
    { path: 'about', component: AboutComponent, canActivate: [isAuthenticated] },
    { path: 'about/version', component: VersionComponent},
    { path: 'about/feedback', component: FeedbackComponent},
    { path: 'about/disclaimer', component: DisclaimerComponent },
    { path: 'about/faq/:path', component: FaqComponent},
    { path: 'admin', component: AdminComponent, canActivate: [isAuthenticated] },
    { path: 'admin/cache-viewer/:id', component: CacheViewerComponent },
    { path: 'redirect', component: RedirectComponent },
    { path: '**', redirectTo: 'flights' },
    //{ path: '**', component: PageNotFoundComponent }
];
